(ns teamoesterreich.admin-mode.data.lr-clearance
  (:require [teamoesterreich.ajax :as ajax]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [goog.json :as json]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.util.log :as log]
            [clojure.walk]
            [teamoesterreich.setup :refer [config]]
            ))



(defn >edit-clearance [clearance-uuid obj cb-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/" clearance-uuid)
                  (ajax/serialize obj)
                  (fn [body status]
                    (log/debug ">edit-clearance done" (json/parse body) status)
                    (when (= status 200)
                      (cb-fn
                        (into {} (clojure.walk/keywordize-keys (js->clj (json/parse body))))
                        )))
                  ))



(defn >clearance-remove-document [clearance-uuid doc-type cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/" clearance-uuid "/removeDocument")
                   (ajax/serialize {:type doc-type})
                   cb-fn))


(defn >user-add-edit-clearance [user-uuid obj cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/user/" user-uuid)
                   (ajax/serialize obj)
                   (fn [data status]
                     (when (= status 200)
                       (log/debug "!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! status " status data)
                       (cb-fn (clojure.walk/keywordize-keys (js->clj (json/parse data))))))))

(defn >validate-clearance [clearance-uuid obj cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/" clearance-uuid "/validate")
                   (ajax/serialize obj)
                   cb-fn))

(defn >extend-clearance [clearance-uuid obj cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/" clearance-uuid "/extend")
                   (ajax/serialize obj)
                   cb-fn))

(defn >reject-clearance [clearance-uuid cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/" clearance-uuid "/reject")
                   (ajax/serialize {})
                   cb-fn))
(defn >end-clearance [clearance-uuid cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/" clearance-uuid "/end")
                   (ajax/serialize {})
                   cb-fn))



(defn qualified-activated? []
  (= (:client config) "toe"))

(defn qualified? [lrClearance]
  (and (qualified-activated?) (not= (:lrClearance-type lrClearance) "EH")))

(defn is-quali [lrClearance]
  (and (:lrClearance-qualification-valid lrClearance)
       (not (h-date/is-passed (:lrClearance-qualification-until lrClearance)))))

(defn is-cleared [lrClearance]
  (log/debug "LR-CLEARANCE is-cleared? "
             (h-date/is-passed (:lrClearance-end lrClearance)) " -- "
             (:lrClearance-valid lrClearance)
             (:lrClearance-end lrClearance)
             (not (h-date/is-passed (:lrClearance-end lrClearance))))
  (and
    (:lrClearance-valid lrClearance)
    (:lrClearance-end lrClearance)
    (not (h-date/is-passed (:lrClearance-end lrClearance))))
  )



(defn is-clearAble [lrClearance]                            ;; TODO move to backend
  (log/debug "LR-CLEARANCE is-clearAble? " (clj->js lrClearance) "\n"
             (get-in lrClearance [:lrClearance-trainingDocument :userDocument-isTraining])
             (get-in lrClearance [:lrClearance-identityDocument :userDocument-isIdentity])
             (get-in lrClearance [:lrClearance-selfExplainDocument :userDocument-isSelfExplain]))
  (and
    (not (:lrClearance-valid lrClearance))
    (get-in lrClearance [:lrClearance-trainingDocument :userDocument-isTraining])
    (get-in lrClearance [:lrClearance-identityDocument :userDocument-isIdentity])
    (get-in lrClearance [:lrClearance-selfExplainDocument :userDocument-isSelfExplain])))



(defn >setMarker [tomId data cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/marker/" tomId)
                   (ajax/serialize data)
                   cb-fn))

(defn >setMarkerMultiple [data cb-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/lr-clearance/marker/multiple")
                   (ajax/serialize data)
                   cb-fn))
